import { useQuery } from '@apollo/client';

import { CustomScriptsQuery } from '~/graphql';

import * as queries from '../settings.queries';

export const useCustomScriptsData = () => useQuery<CustomScriptsQuery>(queries.CustomScriptsQuery);
